import React,{useState,useEffect} from 'react'
import { getStudentUser, getTeacherUser, loginUser, requestPassResetUser } from '../../api/authService'
import useApi from '../../api/useApi'
import {
    Box,
    Typography,
    TextField,
    Button,
    Divider,
    Stack,
  } from "@mui/material";
  import { PersonAdd, Settings } from "@mui/icons-material";
import { Link, useNavigate,useLocation } from 'react-router-dom'
import { toast } from 'react-toastify';
import {useAuth} from '../../hooks/useAuth';



function PassResetForm() {
    const navigate = useNavigate()
    const { login } = useAuth();
    const location = useLocation()

    const redirect = location?.state?.from?.pathname || "/s"; 

    const [form,setForm] = useState({})
    const { request: RequestPassResetuser, data, error, isLoading } = useApi(requestPassResetUser);
    const { request: getStduser, data:stdData, error:stdError } = useApi(getStudentUser);
    const { request: getTchuser, data:tchData, error:tchError } = useApi(getTeacherUser);
    const onchange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
        }; 
    const loginFormInvalid =
        !form?.email?.length ;
    const [viewPass,setViewPass] = useState("password")
    const handleClick = (e)=>{
        e.preventDefault()
        
        // if(!form?.username){
        //     form.username = ""
        // }
        // if(!form?.middle_name){
        //     form.middle_name = ""
        // }
        // console.log(form)
        RequestPassResetuser(form)
        // console.log(isLoading)
        // console.log(data)
        // console.log(error)
        
    }
    
    useEffect(() => {
        if(error){
            console.log(error)
            toast.error(`${JSON.stringify(error?.response?.data,null,2)}`,{position: "top-center"});
            // setForm({})
        }
    },[error])

    useEffect(() => {
        if(stdError){
            toast.error(`${JSON.stringify(stdError?.response?.data,null,2)}`,{position: "top-center"});
            // setForm({})
        }
    },[stdError])

    useEffect(() => {
        if(tchError){
            toast.error(`${JSON.stringify(tchError?.response?.data,null,2)}`,{position: "top-center"});
            // setForm({})
        }
    },[tchError])

    useEffect(() => {
        if(data){
            console.log(data)
            toast.success(`${JSON.stringify(data?.data)}`,{position: "top-center"});
            if(data?.status ===200){
                // const { tokens, ...userData } = data?.data
                // setForm({})
                // if(userData?.is_teacher){
                //     getTchuser({user_id:userData?.id})
                // }else if(userData?.is_student){
                //     getStduser({user_id:userData?.id})
                // }  
                // navigate("/password-reset/confirm") 
                let redirect_url = location?.state?.from?.pathname || "/signin"; 
                setTimeout(()=>{
                    navigate(redirect_url,{ replace: true })
                    },2000)
                    setForm({})
            }
        } 
      }, [data,navigate]);

    useEffect(()=>{

    if(stdData?.status===200){
        const { tokens, ...userData } = data?.data

        login({userData: userData, jwtToken: tokens,student:stdData?.data})
        let redirect_url = location?.state?.from?.pathname || "/s"; 
            setTimeout(()=>{
                navigate(redirect_url,{ replace: true })
                },2000)
                setForm({})
        }
      },[stdData,navigate])


    useEffect(()=>{

     if(tchData?.status===200){
        const { tokens, ...userData } = data?.data

        login({userData: userData, jwtToken: tokens,teacher:tchData})
        let redirect_url_b = location?.state?.from?.pathname || "/t"; 
            setTimeout(()=>{
                navigate(redirect_url_b,{ replace: true })
                },2000)
                setForm({})

       }
      },[tchData,navigate])

    const setView = ()=>(setViewPass("text"))
    const setClose = ()=>(setViewPass("password"))
    return (
        <Box className="Form-Signup" sx={{ display: "flex", flexDirection: "row" }}>
        <Box className="Form-A" sx={{ flex: 1 }}></Box>
  
        <Box className="Form-B" sx={{ flex: 2, textAlign: "center", p: 4 }}>
          {/* Header Title */}
          <Typography variant="h5" gutterBottom>
          Fountain Africa Trust
          </Typography>
  
          {/* Replacing IconGroup */}
          <Stack
            direction="row"
            justifyContent="center"
            alignItems="center"
            spacing={1}
            sx={{ mb: 2 }}
          >
            <PersonAdd sx={{ fontSize: 40, color: "teal" }} />
            <Settings sx={{ fontSize: 25, color: "grey" }} className="spin" />
          </Stack>
  
          <Typography variant="h6" gutterBottom>
            Reset Password
          </Typography>
  
          {/* Form */}
          <Box
            component="form"
            sx={{
              "& .MuiTextField-root": { m: 1, width: "90%" },
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
            noValidate
            autoComplete="off"
          >
            <TextField
              required
              label="Enter your Email"
              type="email"
              name="email"
              placeholder="Enter your @beaconscholars email"
              value={form?.email || ""}
              onChange={onchange}
              variant="outlined"
            />
  
            {/* Submit Button */}
            <Button
              fullWidth
              variant="contained"
              color="primary"
              disabled={loginFormInvalid}
              onClick={handleClick}
              sx={{ mt: 2 }}
            >
              {isLoading ? "Loading..." : "Request Password Reset"}
            </Button>
  
            <Divider sx={{ my: 2 }}>or</Divider>
  
            <Typography variant="body2" sx={{ mt: 1 }}>
              Have a staff account? <Link to="/signin">Sign In</Link>
            </Typography>
            <Typography variant="body2" sx={{ mt: 1 }}>
              Don’t have a staff account? <Link to="/signin">Contact Admin</Link>
            </Typography>
          </Box>
        </Box>
  
        <Box className="Form-C" sx={{ flex: 1 }}></Box>
      </Box>
  )
}

export default PassResetForm